var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"container",attrs:{"cols":"12"}},[_c('h1',{staticClass:"title"},[_vm._v("contacto")]),_c('div',{staticClass:"text_box"},[_c('p',{staticClass:"text"},[_c('a',{attrs:{"href":"mailto:info@matchcalendars.com"}},[_vm._v("info@matchcalendars.com")])])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }